// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"553":"1249c835","591":"82d86bc5","864":"a3ed59c2"}[chunkId] + ".chunk.js";
};